import React, { useEffect, useState, useRef } from 'react';
import { MapContainer, TileLayer, WMSTileLayer } from 'react-leaflet';
import {Marker, ImageOverlay,
  Popup, 
  Polygon, 
  LayersControl, 
  LayerGroup,
  useMap
 } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';  // Import Leaflet Draw CSS
import CustomDrawControl from './CustomDrawControl';  // Import your custom control
import { useNavigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './App.css';  // Import the CSS file for styling
import Spinner from './Spinner'; 
import Downloader from './Downloader';  // Import the Spinner component
import Cookies from 'js-cookie';
import eventEmitter from './eventEmitter';
import DropdownControl from './DropdownControl';
import proj4 from 'proj4';
import {OSM, TileImage, TileWMS} from 'ol/source.js';
import WebGLTileLayer from 'ol/layer/WebGLTile.js';
import {get as getProjection, transformExtent} from 'ol/proj.js';
import {register} from 'ol/proj/proj4.js';





delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const { BaseLayer, Overlay } = LayersControl;
const MapUpdater = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
  }, [center, map]);

  return null;
};


function App1() {
  const [layer, setLayer] = useState('surface-elevation-change');
  const [overlayChecked1, setOverlayChecked1] = useState(true);
  const [overlayChecked2, setOverlayChecked2] = useState('arctic-1');
  const [data, setData] = useState(null);
  const [dataCanadian, setDataCanadian] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [links, setLinks] = useState([]);
  const [linksCanadian, setLinksCanadian] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);
  const [selectedLinkCanadian, setSelectedLinkCanadian] = useState(null);
  const [downloading, setDownloading] = useState(false); // State to track download progress
  const [progress, setProgress] = useState(0);
  const [warning, setWarning] = useState('');
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [timer, setTimer] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const [selectedLayer, setSelectedLayer] = useState(true);
  const [folders, setFolders] = useState(null);
  const [mapCenter, setMapCenter] = useState([128, 40]);
  const [activeOverlay, setActiveOverlay] = useState('arctic-1');
  const fromProjection = 'EPSG:4326';  // WGS84
  const toProjection = 'EPSG:3857';

 const osm3857 = new WebGLTileLayer({
    source: new OSM(),
  });

  const arcticProjection = new L.Proj.CRS(
    'EPSG:3413',
    '+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs',
    {
      origin: [-4194304, 4194304],
      resolutions: [
        8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5
      ],
      bounds: L.bounds([ -4194304, -4194304 ], [ 4194304, 4194304 ])
    }
  );
  console.log(arcticProjection)
  console.log(L.CRS.EPSG3857)
  const [boundingBox, setBoundingBox] = useState({
    xmin: '',
    xmax: '',
    ymin: '',
    ymax: ''
  });

  
  
    const handleOverlayChange = (overlay) => {
      console.log('overlay',activeOverlay)
     
      if (overlay===''){
        const af = localStorage.getItem('activeOverlay')
        if (af==='arctic-1'){
          console.log('af',af)
          setActiveOverlay('arctic-2');
        }
        if (af==='arctic-2'){
          console.log('af2',af)
          setActiveOverlay('arctic-1');
        }
      }
      
      
      if (overlay === 'arctic-1') {
        
       
        if (activeOverlay!='arctic-1'){
        setMapCenter([0,0]);
        setBoundingBox({
          xmin: '',
          xmax: '',
          ymin: '',
          ymax: ''
        })
        setActiveOverlay(overlay);
      }
      } else if (overlay === 'arctic-2') {
       
        if (activeOverlay!='arctic-2'){
        setMapCenter([0,0]);
        setBoundingBox({
          xmin: '',
          xmax: '',
          ymin: '',
          ymax: ''
        })
        setActiveOverlay(overlay);
      }
      }
      
    };
    
  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    Cookies.remove('token');
    setIsAuthenticated(false);
  };


  useEffect(() => {
    fetch('/separated_folders.json')
      .then((response) => response.json())
      .then((data) => setFolders(data))
      .catch((error) => console.error('Error loading JSON:', error));
  }, []);

  useEffect(() => {
   
    fetch('http://127.0.0.1:5001/api/data')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setData(data))
      .catch(error => setError(error.toString()));
    
  }, []);

  useEffect(() => {
   
    fetch('http://127.0.0.1:5001/api/data-canadian')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setDataCanadian(data))
      .catch(error => setError(error.toString()));
    
  }, []);

  useEffect(() => {
    // Set up a timer that updates every second
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);

    // Stop the timer and update the message after 5 seconds (for example)
    setTimeout(() => {
      clearInterval(interval);
      setTimeout(() => {
        console.log('Processing Complete!');
      }, 1000);
      
    }, 200000); // Adjust the time as needed

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange(prevState => ({ ...prevState, [name]: value }));
  };



  
  const handleSubmit = (e) => {
    // Clear previous warnings
    setDownloading(false);
    e.preventDefault();
  setWarning('');

  // Validate date range
  if (new Date(dateRange.endDate) < new Date(dateRange.startDate)) {
    setWarning('End date cannot be earlier than start date.');
    setShowWarningModal(true);
    return; // Prevent form submission
  }
   const bbox1 =`${boundingBox.ymax},${boundingBox.xmin},${boundingBox.ymax},${boundingBox.xmax},${boundingBox.ymin},${boundingBox.xmax},${boundingBox.ymin},${boundingBox.xmin},${boundingBox.ymax},${boundingBox.xmin}`
    console.log('bbox',bbox1 )
    setLoading(true);
    fetch(`http://127.0.0.1:5001/api/link?bbox=${bbox1}&dataset=${activeOverlay}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (activeOverlay==='arctic-2'){
        setLinks(data.link || []);  // Update links based on response
        if (data.link.length > 0) {
          setSelectedLink(data.link[0]);  // Automatically set the first link as selected
        } else {
          setSelectedLink(null);  // Reset image if no links
        }}
        else if (activeOverlay==='arctic-1'){
          setLinksCanadian(data.link || []);  // Update links based on response
          if (data.link.length > 0) {
            setSelectedLinkCanadian(data.link[0]);  // Automatically set the first link as selected
          } else {
            setSelectedLinkCanadian(null);  // Reset image if no links
          }}
        setLoading(false);
        setTimer(0)
      })
      .catch(error => {
        console.error('Error fetching link:', error);
        setLoading(false);
      });
  };
  const handlePolygonClick = (feature) => {
    // Reset date range and links when a different polygon is clicked
    if (selectedFeature !== feature) {
      setDateRange({ startDate: '', endDate: '' });
      setLinks([]);
      setSelectedLink(null);
      setSelectedFeature(feature);
    }
  };
  const closeWarningModal = () => {
    setShowWarningModal(false); // Close the modal
  };
  const handleLinkClick = (link) => {
    setSelectedLink(link);  // Update selected link for image display
  };

  const handleDownload = () => {
    
    setDownloading(true);
  };
  
  const handleClickEachBand = () => {
    const queryString = new URLSearchParams({
      link: selectedLink.aot,
      tci: selectedLink.tci,
      blue: selectedLink.blue
    }).toString();
    
    window.open(`/another-page?${queryString}`,'_blank');
  };

  const proxyUrl = 'https://api.allorigins.win/raw?url=';

  

  const handleBoundingBoxChange = (box) => {
    setBoundingBox({
      xmin: box.xmin,
      xmax: box.xmax,
      ymin: box.ymin,
      ymax: box.ymax
    });
  };

  const handleBoundingBoxInputChange = (e) => {
    const { name, value } = e.target;
    setBoundingBox(prevState => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    const handleLayerChange = (newLayer) => {
      console.log('Layer changed:', newLayer);
      setLayer(newLayer);
      setSelectedLayer(newLayer);
    };

    eventEmitter.on('layerChanged', handleLayerChange);

    // Cleanup on component unmount
    return () => {
      eventEmitter.off('layerChanged', handleLayerChange);
    };
  }, []);

  const arcticCrs = new L.Proj.CRS(
    "EPSG:3413",
    "+proj=stere +lat_0=90 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    {
      resolutions: [
        8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5,
      ],
      origin: [-4194304, 4194304],
      bounds: L.bounds([-4194304, -4194304], [4194304, 4194304]),
    }
  );

  const EPSG3857 = 'EPSG:3857';

// Define WGS84 projection (for lat/lon)
const WGS84 = 'EPSG:4326';

// Function to convert lat/lon to Web Mercator (EPSG:3857)
const convertToWebMercator = (lat, lon) => {
  // Convert from WGS84 (lat/lon) to EPSG:3857
  const webMercatorCoords = proj4(WGS84, EPSG3857, [lon, lat]);
  return webMercatorCoords;
};

const crs1 = new L.Proj.CRS(
  "EPSG:5936",
  "+proj=stere +lat_0=90 +lon_0=-150 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
  {
    origin: [-2.8567784109255E7, 3.2567784109255E7],
    resolutions: [
      238810.81335399998, 119405.40667699999, 59702.70333849987,
      29851.351669250063, 14925.675834625032, 7462.837917312516,
      3731.4189586563907, 1865.709479328063, 932.8547396640315,
      466.42736983214803, 233.21368491607402, 116.60684245803701,
      58.30342122888621, 29.151710614575396, 14.5758553072877, 7.28792765351156,
      3.64396382688807, 1.82198191331174,
    ],
  }
);
const bounds = [
  [80.66742475941662, -72.36786542256804], // SW corner (latitude, longitude)
  [80.80405440466873, -70.62202978349536]  // NE corner (latitude, longitude)
];
  return (
    
    <div className="App pt-0 -mt-0 mb-0 min-h-screen relative pt-[9rem] -mt-[4.25rem] md:-mt-[4.25rem] lg:-mt-[4.25rem] mb-[-3.25rem]  md:mb-[-2.25rem] lg:mb-[-6.25rem] xl:mb-[-13.25rem]">
      
      
       
      <div className="Map-container z-3">
        <span>{overlayChecked1}</span>
        <MapContainer center={[90,0]}  zoom={5} crs={crs1} className="Map">
        
        <LayersControl position="topright" collapsed={false}>
          
          
          <BaseLayer checked name="Arctic Ocean Base">
              <TileLayer
                url="https://services.arcgisonline.com/ArcGIS/rest/services/Polar/Arctic_Ocean_Base/MapServer/tile/{z}/{y}/{x}"
                attribution="&copy; Esri, USGS, NOAA"
                crs={arcticCrs}
              />
            </BaseLayer>
         
          <BaseLayer name="Arctic Satelite">
          <TileLayer
              url="https://services.arcgisonline.com/arcgis/rest/services/Polar/Arctic_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

          </BaseLayer>
         
          <Overlay checked={activeOverlay === 'arctic-1'} name="Arctic 1">
          
      {layer.toLowerCase() === "surface-elevation-change" && folders && (
        <LayerGroup
          eventHandlers={{
            add: () => {setOverlayChecked1(true);
              handleOverlayChange('arctic-1');},
            remove: () => {setOverlayChecked1(false);
              handleOverlayChange('');}
          }}
        >
        {folders.map((folder, index) => (
                <TileLayer
                  key={index}
                  url={`https://testunelyeuwye.adi999.my.id/tiles-5936-JolliffeNArm-topo/{z}/{x}/{y}.png`}
                  minZoom={0}
                  maxZoom={13}  // Adjust based on your tiles
                  attribution=''
                  tms={1}
                  
                  />
        ))}
    
        </LayerGroup>
      )}

{layer.toLowerCase() === "elevation-change" && folders && (
        <LayerGroup
        eventHandlers={{
          add: () => {setOverlayChecked1(true);
            handleOverlayChange('arctic-1');},
          remove: () => {setOverlayChecked1(false);
            handleOverlayChange('');}
        }}
        >
        {folders.map((folder, index) => (
                <TileLayer
                  key={index}
                  url={`http://127.0.0.1:2005/${folder.DhFolders}/{z}/{x}/{y}.png`}
                  minZoom={0}
                  maxZoom={13}  // Adjust based on your tiles
                  attribution=''
                  tms={1}
                  
                  />
        ))}
    
        </LayerGroup>
      )}
    </Overlay>

   



          <Overlay checked={activeOverlay === 'arctic-2'} name="Arctic 2">
    
      {data && data.features.some(feature => feature.geometry.type === 'Polygon') && (
        <LayerGroup 
        eventHandlers={{
          add: () => {handleOverlayChange('arctic-2');},
          remove: () => {handleOverlayChange('');}
        }}
        >
          {data.features.map((feature, index) => {
            if (feature.geometry.type === 'Polygon') {
              const filename = encodeURIComponent(`/mnt/vdb/${feature.properties.name}`);
              
              return (
                <TileLayer
                  key={index}
                  url={`https://tiles.example123.my.id/api/tiles/{z}/{x}/{y}.png?&filename=${filename}&colormap=coolwarm&vmin=-6&vmax=6`}
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
              );
            }
            return null;
          })}
    
        </LayerGroup>
      )}
    </Overlay>

        
        </LayersControl>
        
        {overlayChecked1 && <DropdownControl />}
          
          {/* Add the CustomDrawControl component for drawing tools */}
          <CustomDrawControl onBoundingBoxChange={handleBoundingBoxChange} />

          {activeOverlay==='arctic-2' && data && data.features.map((feature, index) => {
            return feature.geometry.type === 'Point' ? (
              <span></span>
            ) : feature.geometry.type === 'Polygon' ? (
              <Polygon
                key={index}
                positions={feature.geometry.coordinates[0].map(coord => [coord[1], coord[0]])}
                pathOptions={{
                  fillColor: 'blue',
                  fillOpacity: 0,
                  color: 'gray',
                  weight: 1,
                  opacity: 0.5
                }}
                eventHandlers={{
                  click: () => handlePolygonClick(feature)
                }}
              >
                <Popup>
                  <strong>Click download</strong><br />
                  
                    <>
                    <a href={feature.properties.link} target="_blank">
                      <button className="download-button download-button-1" onClick={handleDownload}>
                            Download
                          </button>
                          </a>
                      <br/>
                      <br/>
                    </>
                  
                </Popup>
              </Polygon>
            ) : null;
          })}

{activeOverlay==='arctic-1' && dataCanadian && dataCanadian.features.map((feature, index) => {
            return feature.geometry.type === 'Point' ? (
              <span></span>
            ) : feature.geometry.type === 'Polygon' ? (
              <Polygon
                key={index}
                positions={feature.geometry.coordinates[0].map(coord => [coord[1], coord[0]])}
                pathOptions={{
                  fillColor: 'blue',
                  fillOpacity: 0,
                  color: 'gray',
                  weight: 1,
                  opacity: 0.5
                }}
                eventHandlers={{
                  click: () => handlePolygonClick(feature)
                }}
              >
                <Popup>
                  <strong>Click download</strong><br />
                  
                    <>
                    <a href={feature.properties.link} target="_blank">
                      <button className="download-button download-button-1" onClick={handleDownload}>
                            Download
                          </button>
                          </a>
                      <br/>
                      <br/>
                    </>
                  
                </Popup>
              </Polygon>
            ) : null;
          })}
           <ImageOverlay className="z-[1000]"
    url="https://testunelyeuwye.adi999.my.id/topo2.png" 
    
    bounds={bounds} />
        </MapContainer>
        
        <div className="form-container p-6 bg-white shadow-md rounded-md">
  {/* Form content */}
  <div className="grid grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-gray-700">Xmin: </label>
      <input
        type="number"
        name="xmin"
        value={boundingBox.xmin}
        onChange={handleBoundingBoxInputChange}
        className="mt-1 block w-full border text-gray-700 border-gray-300 rounded-md p-2"
      />
    </div>
    <div>
      <label className="block text-gray-700">Xmax: </label>
      <input
        type="number"
        name="xmax"
        value={boundingBox.xmax}
        onChange={handleBoundingBoxInputChange}
        className="mt-1 block text-gray-700 w-full border border-gray-300 rounded-md p-2"
      />
    </div>
    <div>
      <label className="block text-gray-700">Ymin: </label>
      <input
        type="number"
        name="ymin"
        value={boundingBox.ymin}
        onChange={handleBoundingBoxInputChange}
        className="mt-1 block text-gray-700 w-full border border-gray-300 rounded-md p-2"
      />
    </div>
    <div>
      <label className="block text-gray-700">Ymax: </label>
      <input
        type="number"
        name="ymax"
        value={boundingBox.ymax}
        onChange={handleBoundingBoxInputChange}
        className="mt-1 block w-full text-gray-700 border border-gray-300 rounded-md p-2"
      />
    </div>
  </div>

  <form onSubmit={(e) => handleSubmit(e)} className="mb-4">
    <input type="hidden" name="startDate" value={activeOverlay} />
    <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
      Search
    </button>
  </form>

  {loading ? (
    <div className="spinner-container flex justify-center items-center">
      <Spinner />
    </div>
  ) : (
    <span></span>
  )}

  <div className="popup-content-wrapper">
    <div className="popup-text">
      {activeOverlay === 'arctic-1' && linksCanadian.length > 0 ? (
        linksCanadian.map((link, linkIndex) => (
          <div key={linkIndex} className="link-container mb-2">
            <a
              href="#"
              className={`link text-blue-500 ${selectedLink === link ? 'font-bold' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick(link);
              }}
            >
              {link.name}
            </a>
            <br />
          </div>
        ))
      ) : (
        <span></span>
      )}

      {activeOverlay === 'arctic-2' && links.length > 0 ? (
        links.map((link, linkIndex) => (
          <div key={linkIndex} className="link-container mb-2">
            <a
              href="#"
              className={`link text-blue-500 ${selectedLink === link ? 'font-bold' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick(link);
              }}
            >
              {link.name}
            </a>
            <br />
          </div>
        ))
      ) : (
        <span></span>
      )}
    </div>
  </div>

  <div className="mt-4">
    {activeOverlay === 'arctic-1' && selectedLinkCanadian && (
      <div>
        <br />
        <div>Total image search {selectedLinkCanadian.total_file}</div>
        <div>file id {selectedLinkCanadian.name}</div>
        <div>coordinates {selectedLinkCanadian.coordinates}</div>
        <img
          src={selectedLinkCanadian.thumbnail}
          alt="Popup content"
          className="w-64 h-auto my-2"
        />
        <br />
        <a href={selectedLinkCanadian.data} target="_blank">
          <button className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600">
            Download
          </button>
        </a>
      </div>
    )}
    {downloading && selectedLinkCanadian && (
      <div className="spinner-container">
        <Downloader url1={selectedLinkCanadian.tci} url2={selectedLinkCanadian.blue} />
      </div>
    )}

    {activeOverlay === 'arctic-2' && selectedLink && (
      <div>
        <br />
        <div>Total image search {selectedLink.total_file}</div>
        <div>file id {selectedLink.name}</div>
        <div>coordinates {selectedLink.coordinates}</div>
        <img
          src={selectedLink.thumbnail}
          alt="Popup content"
          className="w-64 h-auto my-2"
        />
        <br />
        <a href={selectedLink.data} target="_blank">
          <button className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600">
            Download
          </button>
        </a>
      </div>
    )}
    {downloading && selectedLink && (
      <div className="spinner-container">
        <Downloader url1={selectedLink.tci} url2={selectedLink.blue} />
      </div>
    )}
  </div>
</div>

      </div>
    </div>
  );
}

export default App1;
